import EAButton from "components/common/EAButton";
import EAIcon from "components/common/EAIcon";
import { useFormContext } from "react-hook-form";
import { isEmpty } from "lodash";
import i18next from 'i18next';

export const AdvancedSearchButtons = ({ handleReset = () => {}, isLoading =false }) => {
  const formMethods = useFormContext();

  return (
    <>
      <EAButton
        content={
          <>
            <EAIcon icon="arrow/replay" />
            {i18next.t('thirdpartySearch.reinitSearch')}
          </>
        }
        colorVariant={"secondary"}
        type="reset"
        size="small"
        customStyle={{
          marginRight: "10px",
          backgroundColor: "#EAEAF0",
          color: "#9A9AAF",
        }}
        onClick={handleReset}
      />
      <EAButton
        type="submit"
        disabled={!isEmpty(formMethods.formState.errors)}
        content={i18next.t('thirdpartySearch.search')}
        colorVariant="primary"
        size="small"
        validateLoading={isLoading}
      />
    </>
  );
};
